import React from 'react';
import toPng from 'to-png';
import slug from 'slug';
import saveAs from 'file-saver';
import { Button } from 'antd';
import BarChart from 'components/Statistics/BarChart';
import 'blueimp-canvas-to-blob';

import styles from './Statistics.module.scss';

class StatsAsBarChart extends React.Component {
  graphRef = React.createRef();

  canvasGraphRef = React.createRef();

  handleExportImgClick = async () => {
    const { filters: { year, type }, zone } = this.props;
    const dayDate = (new Date()).toISOString().split('T')[0];
    const fileName = `${dayDate}-${slug(zone)}-${year}-${type}.png`;
    const canvas = this.canvasGraphRef.current.querySelector('canvas');

    let imgBlob = null;
    /**
     * If toPng method fail,
     * generate charte picture through canvas clone
     */
    try {
      const img = await toPng(this.graphRef.current, 2);
      imgBlob = img.blob;
    } catch (e) {
      imgBlob = canvas && canvas.toBlob
        ? await new Promise(resolve => canvas.toBlob(blob => resolve(blob)))
        : null;
    }

    if (imgBlob) {
      saveAs(imgBlob, fileName);
    }
  }

  render () {
    return (
      <div>
        <div className={styles.export}>
          <Button type="export" icon="download" onClick={this.handleExportImgClick}>Exporter en image</Button>
        </div>
        <div className={styles.graphic}>
          <BarChart {...this.props} />
        </div>
        {/*
          <BarChart /> is duplicated for the snapshot of the chart to save as a file
        */}
        <div className={styles.graphicHide} aria-hidden>
          <div className={styles.graphicHide__container} ref={this.graphRef}>
            <BarChart {...this.props} />
          </div>
          <div className={styles.graphicHide__container} ref={this.canvasGraphRef}>
            <BarChart {...this.props} asCanvas />
          </div>
        </div>
      </div>
    );
  }
}

export default StatsAsBarChart;



// WEBPACK FOOTER //
// ./src/components/Statistics/StatsAsBarChart.js